import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-area" }
const _hoisted_2 = {
  key: 0,
  class: "main-area__main-content main-content"
}
const _hoisted_3 = { class: "main-content__content-container content-container" }
const _hoisted_4 = { class: "content-container__header" }
const _hoisted_5 = { class: "content-container__title" }
const _hoisted_6 = { class: "content-container__edit-field-container edit-field-container" }
const _hoisted_7 = { class: "edit-field-container__content" }
const _hoisted_8 = { class: "content-container__button-container button-container" }

import SimpleSelectField from '@/components/input/SimpleSelectField.vue';
import NumberField from '@/components/input/NumberField.vue';
import { computed, onMounted, reactive, watch } from 'vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { ISelectFormDataSet } from '@/coreDomainsModule/table';
import {
  STEP_OF_CHANGE_DATE,
  STEP_OF_CHANGE_MONTH,
  MIN_OF_CHANGE_DATE,
  MAX_OF_CHANGE_DATE,
  UNIT_OF_DAY,
  UNIT_OF_MONTH_SIMPLE,
  UNIT_OF_WEEK_SIMPLE,
} from '@/coreDomainsModule/constants';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { DateUnitType } from '@/coreDomainsModule/date';
import { i18n } from '@/i18n';
import { convertLeadTimeByUnit } from '@/coreDomainsModule/leadtime';


export default /*@__PURE__*/_defineComponent({
  __name: 'LeadTimePicker',
  props: {
    popupState: { type: Boolean },
    leadTimeSet: {}
  },
  emits: ["onClose", "onConfirm", "onConfirmedInvalidValue", "onUpdateLeadTime"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

// props
const props = __props;

// emits
const emits = __emit;

// イベントフック
onMounted(() => {
  state.popupState = props.popupState;
  updateInfo(props.leadTimeSet);
});

watch(
  () => props.popupState,
  (newVal) => {
    state.popupState = newVal;
    if (state.popupState) {
      updateInfo(props.leadTimeSet);
    }
  }
);

watch(
  () => props.leadTimeSet,
  (newVal) => {
    updateInfo(newVal);
  }
);

// computed
// 数値入力のステップ
const stepOfNumberField = computed(() => {
  switch (state.selectedDateUnit) {
    case 'month':
      return STEP_OF_CHANGE_MONTH;
    default:
      return STEP_OF_CHANGE_DATE;
  }
});

// 変数
const state = reactive<{
  popupState: boolean;
  displayNumber: number;
  selectedDateUnit: DateUnitType;
}>({
  popupState: false,
  displayNumber: 0,
  selectedDateUnit: 'day',
});

// ドロップダウンの選択肢
const options = [
  { label: UNIT_OF_DAY, value: 'day' },
  { label: UNIT_OF_WEEK_SIMPLE, value: 'week' },
  { label: UNIT_OF_MONTH_SIMPLE, value: 'month' },
];

// 関数

/**
 * 表示用のデータを更新する
 * @param value - ポップアップの表示に必要な情報
 */
const updateInfo = (value: ISelectFormDataSet) => {
  if (value === undefined) {
    return;
  }
  if (typeof value.selectedUnit === 'string') {
    if (value.displayData) {
      state.displayNumber = convertLeadTimeByUnit(value.displayData, value.selectedUnit);
    }
    const selectedDateUnit = DateService.convertToIDateUnit(value.selectedUnit);
    if (selectedDateUnit !== 'unknown') {
      state.selectedDateUnit = selectedDateUnit;
    } else {
      // NOTO: 単位情報が'unknown'だったらerror出しとく
      const error = new Error(`Error: stdInventory unit is 'unknown'`);
      console.error(error);
    }
  }
};

/**
 * 数値入力の値が変更されたときの処理
 * @param displayNumber - 数値入力の値
 */
const onChangeNumber = (displayNumber) => {
  if (displayNumber.isValidNumber({})) {
    state.displayNumber = displayNumber;
  }
};

/**
 * 単位の選択肢が変更されたときの処理
 * @param unit - 選択された単位
 */
const onChangeDateUnit = (unit) => {
  if (unit !== undefined) {
    state.selectedDateUnit = unit;
  }
};

/**
 * 確定ボタンが押されたときの処理
 */
const onConfirm = () => {
  // 必要に応じて小数点以下を切り捨てる
  const displayData = DateService.roundDisplayDate(
    state.displayNumber.clamp(MIN_OF_CHANGE_DATE, MAX_OF_CHANGE_DATE),
    state.selectedDateUnit
  );
  emits('onConfirm', {
    displayData: displayData,
    selectedUnit: state.selectedDateUnit,
  });
};

/**
 * DB上のリードタイム情報を更新する
 */
const onUpdateLeadTime = () => {
  // 必要に応じて小数点以下を切り捨てる
  const value = DateService.roundDisplayDate(state.displayNumber.clamp(MIN_OF_CHANGE_DATE, MAX_OF_CHANGE_DATE), state.selectedDateUnit);
  emits('onUpdateLeadTime', value, state.selectedDateUnit);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      class: "outside-area",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onClose')))
    }, null, 512), [
      [_vShow, state.popupState]
    ]),
    (state.popupState)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('リードタイム')), 1),
              _createVNode(TextButton, {
                "button-style": 'btn-secondary',
                size: 'btn-ss',
                class: "content-container__update-default",
                onClick: onUpdateLeadTime
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('デフォルト値更新:1')), 1),
                  _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(_toDisplayString(_unref(t)('デフォルト値更新:2')), 1)
                ], undefined, true),
                _: 1,
                __: [2]
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(NumberField, {
                  "label-square": false,
                  "data-type": "value",
                  "input-value": state.displayNumber,
                  step: stepOfNumberField.value,
                  onChange: onChangeNumber
                }, null, 8, ["input-value", "step"])
              ]),
              _createVNode(SimpleSelectField, {
                class: "edit-field-container__content",
                options: options,
                "selected-value": state.selectedDateUnit,
                "onUpdate:modelValue": onChangeDateUnit
              }, null, 8, ["selected-value"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(TextButton, {
                "button-style": 'btn-secondary',
                size: 'btn-ss',
                class: "button-container__button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('onClose')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('キャンセル')), 1)
                ], undefined, true),
                _: 1
              }),
              _createVNode(TextButton, {
                "button-style": 'btn-primary',
                size: 'btn-ss',
                class: "button-container__button",
                onClick: onConfirm
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('確定')), 1)
                ], undefined, true),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})